/**
 * 订单管理
 */
export default {
  orderList: "/order_info/select_course_order", // 课程订单
  liveOrderList: "/order_info/select_live_order", // 直播订单
  studyTourOrderList: "/StudyOrder/pageList", // 游学订单
  studyTourOrderListDet: "/StudyOrder/detail", // 游学订单详情
  studyTourOrderRefundList: "/orderRefund/orderRefundList", // 游学订单售后
  studyTourOrderRefundListDet: "/orderRefund/orderRefundDetail", // 游学订单售后
  studyTourOrderRefundAudit: "/orderRefund/orderRefundAudit", // 游学订单售后审核
}
